import React, { useState } from 'react'
import ButtonBase from './ButtonBase'
import { INTERAX_COLORS } from '../constants/colors'

export interface ButtonSecondaryProps {
  children: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  fullWidth?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  ariaLabel?: string
  'data-testid'?: string
}

const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  children,
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  ariaLabel,
  'data-testid': dataTestId
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const iconElement = icon && <span className="flex items-center justify-center">{icon}</span>
  // An icon-only button must not render the label's spacer, or the icon sits off-centre.
  const hasLabel = children !== undefined && children !== null && children !== ''

  return (
    <ButtonBase
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      ariaLabel={ariaLabel}
      data-testid={dataTestId}
      className={`
        text-white focus:ring-sun/20 
        disabled:!bg-off-black disabled:text-white-30 
        border-2 border-sun-40 disabled:border-white-30
        flex items-center justify-center transition-all duration-200
        ${className}
      `}
      style={{
        background: isHovered ? INTERAX_COLORS.gradientWhiteSecondaryHover : INTERAX_COLORS.gradientWhiteSecondary
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {iconPosition === 'left' && iconElement}
      {iconPosition === 'left' && icon && hasLabel && <span className="ml-2">{children}</span>}
      {!icon && children}
      {iconPosition === 'right' && icon && hasLabel && <span className="mr-2">{children}</span>}
      {iconPosition === 'right' && iconElement}
    </ButtonBase>
  )
}

export default ButtonSecondary
